<script>
	export let params = {};

	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import PainelBox from '../templates/PainelBox.svelte';
	import {
		API,
		cabecalhoPadraoRequisicao,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';

	const dispatch = createEventDispatcher();
	let distribuicoesPorAvaliador = [];

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN'))
			carregarDistribuicaoAPI(params.flagTipoObjetoListado == 'PROJETO' ? true : false);
		else 
			replace("/login");
	});

	const carregarDistribuicaoAPI = async (tipoObjetoDistribuidoProjeto) => {
		distribuicoesPorAvaliador = [];

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});

		const resposta = await fetch(API('distribuicao-por-avaliador'), {
			method: 'GET',
			headers: tipoObjetoDistribuidoProjeto == true ? cabecalhoPadraoRequisicao(true) : cabecalhoPadraoRequisicao(false)
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const { dados } = await resposta.json();

		if (Object.keys(dados).length == 0) {
			replace("/painel/distribuicao");

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Nenhuma distribuição encontrada.'
			});

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
		
			return;
		}

		if (resposta.status == StatusHttp.OK) {
			distribuicoesPorAvaliador = dados;
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: dados?.mensagem
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}
</script>

<style>
	.scrolling-wrapper {
		overflow-x: scroll;
		overflow-y: hidden;
		white-space: nowrap;
	}
</style>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Distribuição Atual - Agrupado por Avaliador(a)">
		
	<div class="columns mt-4">
		<div class="column has-text-right">
			<p>Outras opções: <strong><a href="#/distribuicao/listagem">Visão geral</a></strong></p>
		</div>
	</div>

	<div class="columns scrolling-wrapper">
		{#each Object.values(distribuicoesPorAvaliador) as distribuicoes}
		<div class="box m-4">
			<a href="#/usuario/visualizar/{distribuicoes[0].usuario.cpf}"><strong>{distribuicoes[0].usuario.nome}</strong></a>
			<br>
			<small>Unidade: <strong>{distribuicoes[0].usuario.unidade_tostring}</strong></small>
			<br>
			<small>Área de interesse: <strong>{distribuicoes[0].usuario.area_interesse_tostring}</strong></small>
			
			<hr>

			<p class="size-is-6 has-text-primary"><strong>PROJETOS/APRESENTAÇÕES</strong>:</p>
			
			<br>

			<ul>
			{#each distribuicoes as distribuicao}
				{#if distribuicao.distribuivel_type == "App\\Models\\Projeto"}
				<li>Código: <strong>{distribuicao.distribuivel?.codigo}</strong></li>
				<li>Título: <strong>{distribuicao.distribuivel?.titulo}</strong></li>
				<li>Alocação: <strong>{distribuicao.distribuivel?.alocacao}</strong></li>
				<li>Unidade: <strong>{distribuicao.distribuivel?.unidade}</strong></li>
				<li>Modalidade: <strong>{distribuicao.distribuivel?.modalidade}</strong></li>
				<li>Data aceite : <strong>{distribuicao.data_aceite ?? 'Aguardando'}</strong></li>
				{:else}
				<li>Inscrição: <strong>{distribuicao.distribuivel?.id}</strong></li>
				<li>Título: <strong>{distribuicao.distribuivel?.projeto.titulo}</strong></li>
				<li>Alocação: <strong>{distribuicao.distribuivel?.projeto.alocacao}</strong></li>
				<li>Unidade: <strong>{distribuicao.distribuivel?.projeto.unidade}</strong></li>
				<li>Modalidade: <strong>{distribuicao.distribuivel?.projeto.modalidade}</strong></li>
				<li>Data aceite : <strong>{distribuicao.data_aceite ?? 'Aguardando'}</strong></li>
				{/if}
				<a href="#/distribuicao/desfazer/confirmacao/{distribuicao.id}" class="tag">Desfazer distribuição</a>
				<hr>
			{/each}
			</ul>
		</div>
		{/each}
	</div>
</PainelBox>
